import React from 'react'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import {
    AppBar,
    Box,
    Hidden,
    IconButton,
    Toolbar,
    makeStyles
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
// import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input'
import Logo from '../../components/Logo'
import firebase from 'firebase/app'

import 'firebase/auth'

const useStyles = makeStyles(() => ({
    root: {},
    avatar: {
        width: 60,
        height: 60
    }
}))

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
    const classes = useStyles()
    const navigation = useNavigate()
    // const [notifications] = useState([]);

    return (
        <AppBar
            className={clsx(classes.root, className)}
            elevation={0}
            {...rest}
        >
            <Toolbar>
                <RouterLink to="/">
                    <Logo />
                </RouterLink>
                <Box flexGrow={1} />
                <Hidden mdDown>
                    {/* <IconButton
            color="inherit"
            onClick={() => {
              console.log(firebase.auth().currentUser);
            }}
          >
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
                    <IconButton
                        color="inherit"
                        onClick={() => {
                            firebase
                                .auth()
                                .signOut()
                                .then(() => {
                                    console.log('user signedout successfully')

                                    navigation('/', { replace: true })
                                })
                                .catch((e) => console.log('error', e))
                        }}
                    >
                        <InputIcon />
                    </IconButton>
                </Hidden>
                <Hidden lgUp>
                    <IconButton color="inherit" onClick={onMobileNavOpen}>
                        <MenuIcon />
                    </IconButton>
                </Hidden>
            </Toolbar>
        </AppBar>
    )
}

TopBar.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func
}

export default TopBar
